import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from 'Components/Modal/StatefulModal';
import CreateEditForm from 'Containers/CreateEditForm';
import {
  createSubjectMutation,
  updateSubjectMutation,
} from 'GraphQL/LSP/mutation/Syllabus.mutation';
import { getSubjects, getSubject } from 'GraphQL/LSP/query/Syllabus.query';

import SubjectForm from './SubjectForm';

export default class SubjectModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    id: PropTypes.string,
    trigger: PropTypes.element,
  };
  static defaultProps = {
    isEdit: false,
  };
  render() {
    const { isEdit, id, trigger, variables } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>{isEdit ? 'แก้ไขวิชา' : 'สร้างวิชา'}</Modal.Header>
            <Modal.Content>
              <CreateEditForm
                dataQuery={getSubject}
                createMutation={createSubjectMutation}
                createRefetchQueries={[
                  {
                    query: getSubjects,
                    variables,
                  },
                ]}
                editMutation={updateSubjectMutation}
                isEdit={isEdit}
                id={id}
                getQueryVariables={({ id }) => ({
                  id,
                })}
                getEditVariables={(form, { id }) => ({
                  id,
                  subjectData: form,
                })}
                getCreateVariables={(form) => ({
                  subjectData: form,
                })}
                onCompleted={closeModal}
                onCancelled={closeModal}
              >
                {({ data, onSubmit }) => {
                  return <SubjectForm initialData={data && data.boSubject} onSubmit={onSubmit} />;
                }}
              </CreateEditForm>
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
